import './Card.css';
export default function Card() {
    return (
        <div className="card">
            <div className='header'>
                <h1 className='center'>My Birthday Card To You 💗💗</h1>
            </div>
            
            <div className="message">
                <h3 className='left dear'>Dear Khatijah</h3>
                <div className='card-m'>
                    <p>
                        You are my heart and soul. My other half as they say, and my life. Without you I might be half dead. Half asleep, half awake, and potentially soulles.
                        I am grateful for the the things that you have done for me. There are just so many things that I could not account for. Most importantly you are the sole 
                        reason I am constantly breathing today. 
                    </p>
                    <p>
                        On this day, I doakan you sentiasa bahagia, dipermudahkan semua urusan you, kalau you hadapi kesusahan you akan sentiasa tenang dan dapat berusaha melalui cabaran dengan baik hahahaha apa I type ni !! 
                        Anyways, I am sorry for everyhing that I pernah buat kat you , kalau you ada terasa cakapla dengan I, kalau takde pun isokay hahahaha
                        Btw Im sorry jugak if this is not the best way to show my feelings towards you , but I hopeyou like it.

                    </p>
                    <p>
                      I hope you have a wonderful day and celebrate the birth of an angel (you) eventhough without me ...
                    </p>
                    <p>
                        I love you !!! and Happy Birthday!!! 🥳🥳
                    </p>
                </div>
                <h3 className='left regards'>
                    Regards, 
                    <br />
                    Adam
                </h3>
            </div>
        </div>
    );
}